class GiftWithPurchaseBar extends HTMLElement {
	constructor() {
		super();

		this.dtcGiftPurchase = null;
		this.configuration = this.getConfigurations();
		this.cart = {};
	}
	static get observedAttributes() {
		return ["cart"];
	}

	attributeChangedCallback(name, oldValue, newValue) {
		if (name === "cart") {
			this.cart = JSON.parse(atob(newValue));
			this.updateProgressBar();
		}
	}
	getConfigurations() {
		let encodedData = this.dataset.configuration;
		let decodedData = atob(encodedData);
		return JSON.parse(decodedData);
	}

	async ajaxCartRequest(method, query, url) {
		try {
			const response = await fetch(url, {
				method: method,
				headers: new Headers({
					Accept: "application/json",
					"Content-Type": "application/json",
				}),
				body: query ? JSON.stringify(query) : null,
			});
			return await response.json();
		} catch (error) {
			console.error("Error:", error);
			throw error;
		}
	}
	async fetchCart() {
		try {
			const data = await this.ajaxCartRequest("GET", null, "/cart.js");
			this.cart = data;
		} catch (error) {
			console.error("Error:", error);
		}
	}
	async connectedCallback() {
		await this.fetchCart();
		await this.updateProgressBar();
	}
	async setFreeGift() {
		try {
			const cart = await this.ajaxCartRequest("GET", null, "/cart.js");
			let { items } = cart;
			let freeGifts = items.filter(
				(item) =>
					item.discounts.length > 0 &&
					item.discounts.find((discount) => discount.title === "Free Gift")
			);
			if (freeGifts.length > 0) {
				freeGifts.map((freeGift) => {
					let { key } = freeGift;
					let cartItem = document.getElementById(`${key}`);
					cartItem
						.querySelector(".upcart-subscription-upgrade-section")
						.classList.add("dtc-hidden");
					cartItem
						.querySelector(".upcart-product-quantity-input")
						.parentNode.classList.add("dtc-hidden");
				});
			}
		} catch (error) {
			console.error("Error:", error);
		}
	}
	setTiers({ remainFreeGift = 0, remainFreeShipping = 0 }) {
		return {
			free_shipping_tier: Math.min(remainFreeShipping, 1),
			free_gift_tier: remainFreeShipping >= 1 ? Math.min(remainFreeGift, 1) : 0,
		};
	}
	icons({ name }) {
		let currentIcons = {
			"free-shipping-icon": `<svg width="20" height="20" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M4 5.25a.75.75 0 0 1 .75-.75h6.991a2.75 2.75 0 0 1 2.645 1.995l.427 1.494a.25.25 0 0 0 .18.173l1.681.421a1.75 1.75 0 0 1 1.326 1.698v1.219a1.75 1.75 0 0 1-1.032 1.597 2.5 2.5 0 1 1-4.955.153h-3.025a2.5 2.5 0 1 1-4.78-.75h-.458a.75.75 0 0 1 0-1.5h2.5c.03 0 .06.002.088.005a2.493 2.493 0 0 1 1.947.745h4.43a2.493 2.493 0 0 1 1.785-.75c.698 0 1.33.286 1.783.748a.25.25 0 0 0 .217-.248v-1.22a.25.25 0 0 0-.19-.242l-1.682-.42a1.75 1.75 0 0 1-1.258-1.217l-.427-1.494a1.25 1.25 0 0 0-1.202-.907h-6.991a.75.75 0 0 1-.75-.75Zm2.5 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path><path d="M3.25 8a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"></path></svg>`,
			"free-gift-icon": `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.6667 8.00001V13.3333C14.6667 13.687 14.5263 14.0261 14.2762 14.2762C14.0262 14.5262 13.687 14.6667 13.3334 14.6667H2.66675C2.31313 14.6667 1.97399 14.5262 1.72394 14.2762C1.47389 14.0261 1.33341 13.687 1.33341 13.3333V8.00001C1.1566 8.00001 0.987034 7.92977 0.86201 7.80475C0.736986 7.67972 0.666748 7.51015 0.666748 7.33334V5.33334C0.666748 4.97972 0.807224 4.64058 1.05727 4.39053C1.30732 4.14049 1.64646 4.00001 2.00008 4.00001H4.11341C4.03807 3.78583 3.99974 3.56039 4.00008 3.33334C4.00008 2.80291 4.2108 2.2942 4.58587 1.91913C4.96094 1.54406 5.46965 1.33334 6.00008 1.33334C6.66675 1.33334 7.25342 1.66668 7.62008 2.16001V2.15334L8.00008 2.66668L8.38008 2.15334V2.16001C8.74675 1.66668 9.33342 1.33334 10.0001 1.33334C10.5305 1.33334 11.0392 1.54406 11.4143 1.91913C11.7894 2.2942 12.0001 2.80291 12.0001 3.33334C12.0004 3.56039 11.9621 3.78583 11.8867 4.00001H14.0001C14.3537 4.00001 14.6928 4.14049 14.9429 4.39053C15.1929 4.64058 15.3334 4.97972 15.3334 5.33334V7.33334C15.3334 7.51015 15.2632 7.67972 15.1382 7.80475C15.0131 7.92977 14.8436 8.00001 14.6667 8.00001ZM2.66675 13.3333H7.33342V8.00001H2.66675V13.3333ZM13.3334 13.3333V8.00001H8.66675V13.3333H13.3334ZM6.00008 2.66668C5.82327 2.66668 5.6537 2.73691 5.52868 2.86194C5.40365 2.98696 5.33342 3.15653 5.33342 3.33334C5.33342 3.51015 5.40365 3.67972 5.52868 3.80475C5.6537 3.92977 5.82327 4.00001 6.00008 4.00001C6.17689 4.00001 6.34646 3.92977 6.47149 3.80475C6.59651 3.67972 6.66675 3.51015 6.66675 3.33334C6.66675 3.15653 6.59651 2.98696 6.47149 2.86194C6.34646 2.73691 6.17689 2.66668 6.00008 2.66668ZM10.0001 2.66668C9.82327 2.66668 9.6537 2.73691 9.52868 2.86194C9.40365 2.98696 9.33342 3.15653 9.33342 3.33334C9.33342 3.51015 9.40365 3.67972 9.52868 3.80475C9.6537 3.92977 9.82327 4.00001 10.0001 4.00001C10.1769 4.00001 10.3465 3.92977 10.4715 3.80475C10.5965 3.67972 10.6667 3.51015 10.6667 3.33334C10.6667 3.15653 10.5965 2.98696 10.4715 2.86194C10.3465 2.73691 10.1769 2.66668 10.0001 2.66668ZM2.00008 5.33334V6.66668H7.33342V5.33334H2.00008ZM8.66675 5.33334V6.66668H14.0001V5.33334H8.66675Z" fill="black"/></svg>`,
			"free-shipping-icon-new": `<img src="https://cdn.shopify.com/s/files/1/0373/4025/0249/files/free-shipping-icon-new.svg?v=1741182875" alt="" />`,
			"free-gift-icon-new": `<img src="https://cdn.shopify.com/s/files/1/0373/4025/0249/files/free-gift-icon-new.svg?v=1741183307" alt="" />`,
		};
		return currentIcons[name];
	}
	fillColorDropdown({ availableVariants, product }) {
		let colors = [];
		let colorOptions = "";

		availableVariants.forEach((variant) => {
			if (
				!colors.some((color) => color.label === variant.option1) &&
				variant.available &&
				variant.barcode !== ""
			) {
				colors.push({
					label: variant.option1,
					img:
						product?.media?.find(
							(img) => img.id === variant?.featured_media?.id
						)?.src || "",
				});
			}
		});
		colors.forEach((color) => {
			colorOptions += `<option value="${color.label}" data-image="https://${color.img}">${color.label}</option>`;
		});
		return { colorOptions, colors };
	}
	renderFreeShippingBar({ free_shipping_tier, message }) {
		let template = `
			<div class="dtc-gift-purchase">
					<div class="content">
						<h3 class="remain-message">${message}</h3>
						<div class="progress-bar-container ${free_shipping_tier == 1 && `second-half`}">
							<div class="tier alone freeshipping-tier ${free_shipping_tier == 1 && `dtc-completed`}">
								<div class="progress-bar__container">
									<div style="width: ${free_shipping_tier * 100}%;" class="progress-bar"></div>
								</div>
								<div class="message-container free-shipping-message">
									<span class="message-icon">
										${this.icons({ name: "free-shipping-icon" })}
									</span>
									<span class="message-content">
										Free Shipping 1
									</span>
								</div>
							</div>
						</div>
					</div>
				  </div>
			</div>
    `;
		return template;
	}
	renderGWPContent({
						 product,
						 displayFreeGiftProduct,
						 message,
						 free_shipping_tier,
						 free_gift_tier,
					 }) {
		const availableVariants = product?.variants || [];

		const { colorOptions, colors } = this.fillColorDropdown({
			availableVariants,
			product,
		});
		let imageURL = colors.length > 0? colors[0].img: product.images[0]
		let template = `
			<div class="dtc-gift-purchase">
			<div class="content">
				<h3 class="remain-message">${message}</h3>
				<div class="progress-bar-container ${free_shipping_tier == 1 && `second-half`}">
					<div class="tier freeshipping-tier ${free_shipping_tier == 1 && `dtc-completed`}">
						<div class="progress-bar__container">
							<div style="width: ${free_shipping_tier * 100}%;" class="progress-bar"></div>
						</div>
						<div class="message-container free-shipping-message free-shipping-cart-1">
							<span class="message-icon">
								${this.icons({ name: "free-shipping-icon" })}
							</span>
							<span class="message-content">
								Free Shipping
							</span>
						</div>
						<div class="message-container free-shipping-message free-shipping-cart-2" style="top:-10px !important;">
							<span class="w-[30px] h-[30px] border border-black rounded-full flex items-center justify-center" style="background-color: #F2F2F2"> 
								${this.icons({ name: "free-shipping-icon-new" })}
							</span>
							<span class="message-content font-Inter text-10">
								Free Shipping
							</span>
						</div>
					
				
					</div>
					<div class="tier freegift-tier ${free_gift_tier == 1 && `dtc-completed`}">
						<div class="progress-bar__container">
							<div style="width: ${free_gift_tier * 100}%;" class="progress-bar"></div>
						</div>
						<div class="message-container free-gift-message free-gift-cart-1">
							<span class="message-icon">
								${this.icons({ name: "free-gift-icon" })}
							</span>
							<span class="message-content">
								Free Gift
							</span>
						</div>
						<div class="message-container free-gift-message free-gift-cart-2" style="top:-10px !important;">
							<span class="w-[30px] h-[30px] border border-black rounded-full flex items-center justify-center" style="background-color: #F2F2F2">
								${this.icons({ name: "free-gift-icon-new" })}
							</span>
							<span class="message-content font-Inter text-10">
								Scent Booster<br/>$25 Value
							</span>
						</div>
					</div>
				</div>
			</div>
			<div class="ig-dp-container ${!displayFreeGiftProduct && `dtc-hidden`}">
				<div class="free-gift">
					<div class="free-gift-image">
						<img 
							src="${imageURL}" 
							alt="${product.title}"
							width="100"
							height="100"
							loading="lazy"
							/>
					</div>
			
					<div class="free-gift-content">
						<h4>${product.title}</h4>

						<div class="product-info">
							<div class="selectors">
								<div class="selector-wrapper color-selector">
									<div class="form-group">
										<select name="color" id="color" class="select2 color-options" style="width: 100%" dtc-hidden>
                      <option value="">Select Scent</option>
											${colorOptions}
										</select>
									</div>
								</div>
							</div>

							<p class="price">
								<span>${this.formatMoney(product.price)}</span>
								<span class="price-text">FREE</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
			</div>
		`;
		return template;
	}

	initSelect2() {
		let selectElement = this.querySelector(".select2.color-options");

		$(selectElement).select2({
			dropdownParent: $(this.querySelector(".color-selector")),
			minimumResultsForSearch: Infinity,
		});
	}

	initGiftListener(variants) {
		let _this = this;
		const productVariants = variants || [];
		const selector = this.querySelector(".select2.color-options");

		$(selector).on("select2:select", async (event) => {
			const selected = {};
			const colorDropdown = this.querySelector("#color");


			if (!colorDropdown?.value || colorDropdown?.value === "") return;

			selected.color = colorDropdown.value;

			try {
				const id = productVariants.find(
					(variant) => variant.title === selected?.color
				)?.id;
				const productData = {
					id,
					quantity: 1,
					properties: {
						_free_gift: true,
					},
				};
				await _this.ajaxCartRequest("POST", productData, "/cart/add.js");
				console.info("√ Gift added successfully.");
			} catch (error) {
				console.error("x error: ", error);
			}
		});
	}

	formatMoney(cents) {
		if (typeof cents == "string") {
			cents = cents.replace(".", "");
		}

		var precision = 2;

		if (Number(cents) % 100 === 0) {
			precision = 0;
		}

		return "$" + this.formatWithDelimiters(cents, precision);
	}

	formatWithDelimiters(number, precision, thousands, decimal) {
		precision = this.defaultOption(precision, 2);
		thousands = this.defaultOption(thousands, ",");
		decimal = this.defaultOption(decimal, ".");

		if (isNaN(number) || number == null) return 0;

		number = (number / 100.0).toFixed(precision);

		var parts = number.split("."),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
			cents = parts[1] ? decimal + parts[1] : "";

		return dollars + cents;
	}

	defaultOption(opt, def) {
		return typeof opt == "undefined" ? def : opt;
	}
	getRemainingContent({ total, cart }) {
		let totalRemaining = total - cart.total_price;
		let remainingPercentage = 1 - totalRemaining / total;
		let remainingPercentageRounded =
			Math.round(remainingPercentage * 10000) / 10000;
		let formattedTotalRemaining = this.formatMoney(totalRemaining);
		return {
			formattedTotalRemaining,
			remainingPercentageRounded,
		};
	}
	getUpdatedMessage({ message, keywords = [], replace = [] }) {
		let updatedMessage = message;

		if (keywords.length !== replace.length) return { updatedMessage };
		keywords.forEach((keyword, index) => {
			updatedMessage = updatedMessage.replace(keyword, replace[index]);
		});
		return {
			updatedMessage,
		};
	}
	findFreeGift({ cart, productHandle }) {
		const freeGift =
			cart?.items.find(
				(item) => item?.handle === productHandle && item?.properties?._free_gift
			) || false;
		const cartKey = freeGift?.key || false;
		const freeGiftId = freeGift?.id || false;
		return { cartKey, freeGiftId };
	}
	evaluateCartStatus(
		cartTotalPrice,
		cartKey,
		product,
		cartGiftWithPurchaseLimit,
		remaininFreeShippingPercentage,
		remaininFreeGiftPercentage,
		remainFreeShippingMessage,
		remainFreeGiftMessage,
		freeGiftMessageCompletedUpdated,
		freeShippingMessageCompletedUpdated
	) {
		const { free_shipping_tier, free_gift_tier } = this.setTiers({
			remainFreeShipping: remaininFreeShippingPercentage,
			remainFreeGift: remaininFreeGiftPercentage,
		});
		let message = remainFreeShippingMessage;
		let displayFreeGiftProduct = false;

		if (free_shipping_tier < 1) {
			message = remainFreeShippingMessage;
		}
		if (free_shipping_tier === 1 && product === "") {
			message = freeShippingMessageCompletedUpdated;
		}
		if (
			free_shipping_tier === 1 &&
			free_shipping_tier + free_gift_tier > 1 &&
			product !== ""
		) {
			message = remainFreeGiftMessage;
		}
		if (cartTotalPrice >= cartGiftWithPurchaseLimit) {
			message = freeGiftMessageCompletedUpdated;
			displayFreeGiftProduct = true;
		}
		if (cartKey) {
			displayFreeGiftProduct = false;
		}

		return {
			message,
			displayFreeGiftProduct,
			free_shipping_tier,
			free_gift_tier,
		};
	}
	async updateProgressBar() {
		const {
			cart_gift_with_purchase_limit,
			cart_gift_with_purchase_product: product,
			free_shipping_message,
			free_gift_message,
			free_gift_message_completed,
			shipping_threshold,
			shipping_threshold_unlocked_message,
		} = this.configuration;

		const cartGiftWithPurchaseLimit =
			cart_gift_with_purchase_limit * Shopify.currency.rate;
		const shipping_value = shipping_threshold * Shopify.currency.rate;

		const {
			formattedTotalRemaining: formatedRemainingFreeShipping,
			remainingPercentageRounded: remaininFreeShippingPercentage,
		} = this.getRemainingContent({ total: shipping_value, cart: this.cart });
		const {
			formattedTotalRemaining: formatedRemainingFreeGift,
			remainingPercentageRounded: remaininFreeGiftPercentage,
		} = this.getRemainingContent({
			total: cartGiftWithPurchaseLimit,
			cart: this.cart,
		});

		const { updatedMessage: remainFreeShippingMessage } =
			this.getUpdatedMessage({
				message: free_shipping_message,
				keywords: ["*remain*"],
				replace: [formatedRemainingFreeShipping],
			});
		const { updatedMessage: freeShippingMessageCompletedUpdated } =
			this.getUpdatedMessage({
				message: shipping_threshold_unlocked_message,
			});
		const { updatedMessage: remainFreeGiftMessage } = this.getUpdatedMessage({
			message: free_gift_message,
			keywords: ["*remain*", "*product_title*"],
			replace: [formatedRemainingFreeGift, product.title],
		});
		const { updatedMessage: freeGiftMessageCompletedUpdated } =
			this.getUpdatedMessage({
				message: free_gift_message_completed,
				keywords: ["*product_title*"],
				replace: [product.title],
			});
		const { cartKey, freeGiftId } = this.findFreeGift({
			cart: this.cart,
			productHandle: product.handle,
		});
		const {
			message,
			displayFreeGiftProduct,
			free_shipping_tier,
			free_gift_tier,
		} = this.evaluateCartStatus(
			this.cart.total_price,
			cartKey,
			product,
			cartGiftWithPurchaseLimit,
			remaininFreeShippingPercentage,
			remaininFreeGiftPercentage,
			remainFreeShippingMessage,
			remainFreeGiftMessage,
			freeGiftMessageCompletedUpdated,
			freeShippingMessageCompletedUpdated
		);
		if (product === "") {
			let GWPComponent = this.renderFreeShippingBar({
				free_shipping_tier,
				message,
			});
			this.innerHTML = GWPComponent;
			return;
		}
		let GWPComponent = this.renderGWPContent({
			product,
			displayFreeGiftProduct,
			message,
			free_shipping_tier,
			free_gift_tier,
		});
		this.innerHTML = GWPComponent;
		this.initSelect2();

		this.initGiftListener(product.variants);
		if (cartKey && this.cart.total_price < cartGiftWithPurchaseLimit) {
			this.updateItemQuantity({ cartKey });
		}
	}

	async updateItemQuantity({ cartKey }) {
		let updates = {};
		updates[cartKey] = 0;
		try {
			const data = await this.ajaxCartRequest(
				"POST",
				{ updates },
				"/cart/update.js"
			);
			this.updateProgressBar();
			return window.upcartRefreshCart();
		} catch (error) {
			console.error("Error:", error);
		}
	}
}

customElements.define("gift-with-purchase-bar", GiftWithPurchaseBar);
